import { useState, useEffect } from "react";
import "./newMaterial.css";
import { addMaterial } from "../../redux/apiCalls";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { publicRequest } from "../../requestMethods";
import { useHistory } from "react-router-dom";

export default function NewMaterial() {
    const DEFAULT_MATERIAL_CATEGORY_ID = "69832ba4412f46e3c0c8dec2";
    const ITEM_GROUP_OPTIONS = [
        "ACCESSOR",
        "ACP",
        "ALUMINIUM",
        "PVC ACC",
        "ALUMINIUM-T",
        "ALUMINUM-ROUVERS",
        "Machine",
        "GLASS",
        "POLY",
        "PVC PIPE",
        "STEEL HO",
        "STAINLESS STEEL",
    ];
    const dispatch = useDispatch();
    const history = useHistory();
    const [principles, setPrinciples] = useState([]);
    
    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin === true : null
    );
    const purchaser = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "purchaser"
            : null
    );
    const outright = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "outright"
            : null
    );
    const currentUser = useSelector((state) => state.user.currentUser);

    const [inputs, setInputs] = useState({ itemgroup: "ACCESSOR" });

    const canCreateMaterial = superadmin || purchaser || outright;

    // Redirect if user is not allowed to create materials
    useEffect(() => {
        if (canCreateMaterial === false) {
            history.push("/");
        }
    }, [canCreateMaterial, history]);

    // For purchaser, lock principle to their own outlet
    useEffect(() => {
        if (purchaser && currentUser?._id) {
            setInputs((prev) => {
                if (prev.principle === currentUser._id) return prev;
                return { ...prev, principle: currentUser._id };
            });
        }
    }, [purchaser, currentUser?._id]);

    const getAllPrinciples = async () => {
        try {
            const params = {
                type: ["outright"],
            };

            const res = await publicRequest.get("/users/admin", {
                params,
            });
            setPrinciples(res.data);
        } catch (err) {
            console.error("Error fetching principles:", err);
        }
    };

    useEffect(() => {
        if (principles.length === 0) {
            getAllPrinciples();
        }
    }, [principles.length]);

    const handleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handlePrincipleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, principle: e.value };
        });
    };

    const handleItemGroupChange = (e) => {
        setInputs((prev) => {
            return { ...prev, itemgroup: e ? e.value : "ACCESSOR" };
        });
    };

    const handleClick = async () => {
        if (!inputs.title) {
            alert("Please enter a material title");
            return;
        }
        // Determine principle to save with the material
        // - Superadmin: use selected principle from inputs (can be undefined)
        // - Other users (e.g. purchaser): use their principle if available, otherwise their own user ID
        let principleToUse = inputs.principle;
        if (!superadmin) {
            if (currentUser?.principle) {
                principleToUse = currentUser.principle;
            } else if (currentUser?._id) {
                principleToUse = currentUser._id;
            }
        }

        const material = {
            ...inputs,
            category: DEFAULT_MATERIAL_CATEGORY_ID,
            principle: principleToUse,
        };
        addMaterial(material, dispatch);
    };

    if (!canCreateMaterial) {
        return null;
    }

    return (
        <div className="newMaterial">
            <h1 className="addProductTitle">New Material</h1>
            <div className="addMaterialForm">
                <div className="addProductItem">
                    <label>Material Title *</label>
                    <input
                        name="title"
                        type="text"
                        placeholder="Material Title"
                        onChange={handleChange}
                    />
                </div>

                <div className="addProductItem itemCodeRow">
                    <label>Item Code</label>
                    <input
                        name="itemCode"
                        type="text"
                        placeholder="Item Code"
                        onChange={handleChange}
                    />
                </div>

                <div className="addProductItem itemCodeRow">
                    <label>Item Group *</label>
                    <Select
                        options={ITEM_GROUP_OPTIONS.map((group) => ({
                            label: group,
                            value: group,
                        }))}
                        value={{
                            label: inputs.itemgroup || "ACCESSOR",
                            value: inputs.itemgroup || "ACCESSOR",
                        }}
                        onChange={handleItemGroupChange}
                        placeholder="Select Item Group"
                        isClearable={false}
                    />
                </div>

                {superadmin && (
                    <div className="addProductItem">
                        <label>Principle</label>
                        <Select
                            options={principles.map((user, i) => {
                                return { label: user.name || user.email, value: user._id };
                            })}
                            onChange={handlePrincipleChange}
                            placeholder="Select Principle (Optional)"
                            isClearable
                        />
                    </div>
                )}

                <button onClick={handleClick} className="addMaterialButton formCreateButton">
                    Create
                </button>
            </div>
        </div>
    );
}
